import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "../ModalHeader";
import ReplaceIDCard from "../../pages/Hire/ReplaceIDCard";

const ReplaceID = ({ id, setResetID }) => {

  const [welcome, setWelcome] = useState(false);
  const handleCloseWelcome = () => setWelcome(false);
  const handleWelcome = () => setWelcome(true);

  return (
    <div>
      <button onClick={handleWelcome} style={{ backgroundColor: 'orange', color: 'white', padding: '4px 10px', margin: '5px', border: 'none', borderRadius: '5px', fontWeight: "bold", marginLeft: '5px' }}>

        Replace ID
      </button>
      <Modal show={welcome} onHide={handleCloseWelcome} centered>
        <ModalHeader setShow={setWelcome} headerTitle={"Replace Identity Card"} />
        <Modal.Body>
          <ReplaceIDCard id={id} setResetID={setResetID} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseWelcome}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ReplaceID;
